import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1eab1aec"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "dropdown"
}
const _hoisted_2 = ["name", "disabled", "placeholder"]
const _hoisted_3 = { class: "dropdown-content" }
const _hoisted_4 = ["onMousedown"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.options)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          class: "dropdown-input",
          name: _ctx.name,
          onFocus: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showOptions())),
          onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.exit())),
          onKeyup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.keyMonitor && _ctx.keyMonitor(...args))),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchFilter) = $event)),
          disabled: _ctx.disabled,
          placeholder: _ctx.placeholder
        }, null, 40, _hoisted_2), [
          [_vModelText, _ctx.searchFilter]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredOptions, (option, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "dropdown-item",
              onMousedown: ($event: any) => (_ctx.selectOption(option)),
              key: index
            }, _toDisplayString(option?.name), 41, _hoisted_4))
          }), 128))
        ], 512), [
          [_vShow, _ctx.optionsShown]
        ])
      ]))
    : _createCommentVNode("", true)
}